/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Selected meter type to filter by.
 */
export type SmartMetersDashboardDownloadRequestSelectedMeterType =
  (typeof SmartMetersDashboardDownloadRequestSelectedMeterType)[keyof typeof SmartMetersDashboardDownloadRequestSelectedMeterType]

export const SmartMetersDashboardDownloadRequestSelectedMeterType = {
  GAS: "GAS",
  ELEC: "ELEC",
  BOTH: "BOTH",
} as const
